const remToPx = rem => {
  let clientWidth = document.documentElement.clientWidth
  clientWidth = clientWidth > 800 ? 750 : clientWidth
  clientWidth = clientWidth < 320 ? 320 : clientWidth
  return (rem * 100 * clientWidth) / 750
}

export default remToPx
